<template>
  <button class="button theme-switch-button" @click="handleClick">
    <img :src="iconPath" alt="Dark" />
  </button>
</template>

<script>
export default {
  props: ["isDark"],
  methods: {
    handleClick() {
      this.$emit("update:theme", { isDark: !this.isDark });
    }
  },
  computed: {
    iconPath() {
      return this.isDark
        ? require("@/assets/img/sun.svg")
        : require("@/assets/img/moon.svg");
    }
  }
};
</script>

<style lang="scss" scoped>
.theme-switch-button {
  position: absolute;
  background: transparent;
  top: 5vh;
  right: 5vw;
  border: none;
  outline: none;
  box-shadow: none !important;
}
</style>
